import ProgressContainer from './components/ProgressBar/ProgressContainer';
import PromoContainer from './components/Promos/PromoContainer';
import SignUpFormContainer from './components/SignupForm/SignUpFormContainer';
import Store from './state/Store';
import UserInfoComponent from './components/UserInfo/UserInfoComponent';
import KeepAlive from './components/KeepAlive';
import * as React from 'react';
import '../src/common/flexboxgrid.css';
import './App.css';
import qs from 'qs';
import {useTranslation} from "react-i18next";
import WaitingRoom from './components/WaitingRoom/WaitingRoom';
import ThankYou from './components/ThankYou/ThankYou';
import TrusteComponent from './common/Truste/TrusteComponent';

const Home = (props) => {
  const sourceType = qs.parse(props.location.search, { ignoreQueryPrefix: true }).sourceType;
  const source = qs.parse(props.location.search, { ignoreQueryPrefix: true }).source;
  const promoSourceType = sourceType !== undefined ? sourceType : (source !== undefined ? source : "");
  const promoReferrer = document.referrer;
  const programType = qs.parse(props.location.search, { ignoreQueryPrefix: true }).programType;
  const verifyEmailToken = qs.parse(props.location.search, { ignoreQueryPrefix: true }).verify_email;
  
  const {t} = useTranslation();

  return (
    <div>
      <header>
        <div className="brandingBar">
          <div className="oLogo"></div>
          <div className="oLogoWords title7">Cloud Infrastructure</div>
        </div>
      </header>
      <main id="main">
        <Store>
          <div className="row">
            <div className="col-md-4 col-xs-12 sidebar">
              <ProgressContainer />
              <PromoContainer />
            </div>
            <div className="col-md-8 col-xs-12 mainContainer">
              <KeepAlive />
              <SignUpFormContainer sourceType={promoSourceType} referrer={promoReferrer} programType={programType} verifyEmailToken={verifyEmailToken}/>
              <UserInfoComponent />
              <ThankYou />
            </div>
            <WaitingRoom />
          </div>
        </Store>
        

        
      </main>
      
      <footer>
        <div className="row">
          <div className="footer-len-container col-sm-7 col-xs-12">
            <a href="https://www.oracle.com/legal/privacy/index.html">{t('footer.terms', 'Terms of Use and Privacy')}</a>
            <TrusteComponent />
            <a href="https://www.oracle.com/legal/privacy/privacy-policy.html#advertising">{t('footer.adChoices', 'Ad Choices')}</a>
          </div>
          <div className="col-sm-5 col-xs-12 copyright">
            {t('footer.copyright')}
          </div>
        </div>
      </footer>
      
    </div>
  )
}

export default Home;